/** 1. 玩家身份标签 (互斥：二选一) */
export type IdentityTag = '固定主角' | '自定主角'

/** 2. 类型标签 (互斥：三选一) */
export type OrientationTag = '女性向' | '男性向' | '其他性向' | '全性向'

/** 2. 左右位标签 (互斥：六选一) */
export type PositionTag = 'BL' | 'GL' | 'BG' | 'GB' | '无' | 'All'

/** 3. 题材标签 (非互斥：预设 + 自定义) */
export type ThemeTag =
  // 基础分类
  | '玄幻'
  | '西幻'
  | '校园'
  | '历史'
  | '悬疑'
  | '日常'
  | '现代'
  | '科幻'
  | '仙侠'
  | '同人'
  // 场景与世界观 (来自图片)
  | '古风'
  | '宫廷'
  | '豪门'
  | '都市'
  | '无限'
  | '末世'
  | '武侠'
  | '机甲'
  | '克系'
  | '异界'
  | '修真'
  | '竞技'
  | '神话'
  | '经营'
  | '基建'
  | '养成'
  | '剧情'
  | '史诗'
  | '群像'
  | '工具'
  | '大界'
  | '权谋'
  | '惊悚'
  | '二创'
  | '架空'
  | '自由'
  // 人设与互动特征 (来自图片)
  | '反派'
  | '魔物'
  | '机械'
  | '女强'
  | '病娇'
  | '腹黑'
  | '毒舌'
  | '温柔'
  | '高冷'
  | '年上'
  | '年下'
  | '青梅'
  | '忠犬'
  | '强制'
  | '诱惑'
  | '治愈'
  | '甜宠'
  | '虐恋'
  | '轻设'
  | '伪装'
  // 特殊/亚文化 (来自图片)
  | '扶她'
  | '变装'
  | '牛头'
  | '纯爱'
  | '青涩'
  | '生子'
  | '兽耳'
  | (string & {})

/** * 汇总标签类型 */
export type Tag = IdentityTag | OrientationTag | PositionTag | ThemeTag

// 互斥组定义
export const TAG_GROUPS = {
  //互斥
  identity: {
    label: '玩家身份',
    exclusive: true,
    tags: ['固定主角', '自定主角'] as IdentityTag[],
  },
  //互斥
  orientation: {
    label: '类型',
    exclusive: true,
    tags: ['女性向', '男性向', '其他性向', '全性向'] as OrientationTag[],
  },
  //互斥
  position: {
    label: '左右位',
    exclusive: true,
    tags: ['BL', 'GL', 'BG', 'GB', 'All'] as PositionTag[],
  },

  // 题材：核心背景
  genre: {
    label: '题材背景',
    exclusive: false,
    tags: [
      '玄幻',
      '西幻',
      '校园',
      '历史',
      '悬疑',
      '日常',
      '现代',
      '科幻',
      '仙侠',
      '同人',
      '古风',
      '宫廷',
      '豪门',
      '都市',
      '无限',
      '末世',
      '武侠',
      '机甲',
      '克系',
      '异界',
      '修真',
      '竞技',
      '神话',
      '大世界',
      '权谋',
      '架空',
    ] as ThemeTag[],
  },
  // 玩法与叙事风格
  style: {
    label: '玩法风格',
    exclusive: false,
    tags: ['养成', '剧情', '史诗', '群像', '二创', '自由'] as ThemeTag[],
  },
  // 人设与情感萌点
  character: {
    label: '角色互动',
    exclusive: false,
    tags: [
      '病娇',
      '腹黑',
      '毒舌',
      '温柔',
      '高冷',
      '年上',
      '年下',
      '青梅',
      '忠犬',
      '强势',
      '诱惑',
      '治愈',
      '甜宠',
      '虐恋',
      '反派',
      '魔物',
      '伪装',
      '纯爱',
      '青涩',
    ] as ThemeTag[],
  },
}
